import { useState } from "react";
import { Link } from "react-router-dom";

export default function Portfolio() {
    // Daftar project (dummy)
    const projects = [
        { id: 1, title: "Concept Design", image: "/images/1.jpg", description: "Concept Design Video Wall System" },
        { id: 2, title: "Concept Design", image: "/images/3.jpg", description: "Concept Design Motorized Screen for Meeting Room" },
        { id: 3, title: "Concept Design", image: "/images/2.jpg", description: "Concept Design Videotron System" },
        { id: 4, title: "Concept Design", image: "/images/4.jpg", description: "Concept Design Interactive Display" },
        { id: 5, title: "Concept Design", image: "/images/5.jpg", description: "Concept Design Videotron System" },
        { id: 6, title: "Concept Design", image: "/images/6.jpg", description: "Concept Design Videotron System" }
    ];

    // State untuk modal
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedProject, setSelectedProject] = useState(null);

    // Fungsi untuk membuka modal
    const openModal = (project) => {
        setSelectedProject(project);
        setIsModalOpen(true);
    };

    // Fungsi untuk menutup modal
    const closeModal = () => {
        setIsModalOpen(false);
        setSelectedProject(null);
    };

    return (
        <section id="portfolio" className="portfolio-section section">
            <div className="container">
                <h2 className="section-title">Our Work</h2>
                <div className="portfolio-grid">
                    {projects.map((project) => (
                        <div key={project.id} className="portfolio-item" onClick={() => openModal(project)}>
                            <img src={project.image} alt={project.title} />
                            <div className="portfolio-overlay">
                                <h4>{project.title}</h4>
                                <p>{project.description}</p>
                            </div>
                        </div>
                    ))}
                </div>
                <div className="text-center mt-5">
                    <Link to="/works" className="btn btn-neon">Lihat Selengkapnya</Link>
                </div>

                {/* Modal Portfolio */}
                {isModalOpen && selectedProject && (
                    <div className="modal-overlay-portfolio" onClick={closeModal}>
                        <div className="modal-content-portfolio" onClick={(e) => e.stopPropagation()}>
                            {/* Close Button */}
                            <button className="modal-close-portfolio" onClick={closeModal}>×</button>

                            <div className="modal-left-portfolio">
                                <img src={selectedProject.image} alt={selectedProject.title} />
                            </div>
                            <div className="modal-right-portfolio">
                                <h3 className="modal-title">{selectedProject.title}</h3>
                                <p className="modal-description">{selectedProject.description}</p>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </section>
    );
}